import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $convertFromMarkdownString,
  $convertToMarkdownString,
} from '@lexical/markdown';
import {
  COMMAND_PRIORITY_NORMAL,
  createCommand,
  LexicalCommand,
} from 'lexical';
import { LOAD_TRANSFORMERS, SAVE_TRANSFORMERS } from '../transformers';
import { getSummaryForViewMode } from '../../../Attachments/InlineAttachment';
import { useImpressionEditorContext } from '../../Context';
import { stripCitationMarkersFromMarkdown } from '../stripCitationMarkdown';

export const STRIP_CITATIONS_COMMAND: LexicalCommand<void> = createCommand();

export const StripCitationsPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const { activeImpression, viewMode } = useImpressionEditorContext();

  useEffect(() => {
    return editor.registerCommand(
      STRIP_CITATIONS_COMMAND,
      () => {
        editor.update(() => {
          const markdown = $convertToMarkdownString(SAVE_TRANSFORMERS);
          const stripped = stripCitationMarkersFromMarkdown(markdown);
          activeImpression.applyStrippedSummaryMarkdown(stripped);
          const editorContent =
            activeImpression.reviewDiffDocument ??
            activeImpression.summary ??
            '';
          $convertFromMarkdownString(
            getSummaryForViewMode(editorContent, viewMode),
            LOAD_TRANSFORMERS,
          );
        });
        return true;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor, activeImpression, viewMode]);

  return null;
};
